import React, {useRef, useState} from 'react';
import styles from "./term-sheet-securities.module.scss";
import {Col, Row, Table} from "react-bootstrap";
import detailsArrowIcon from "../../../../../../assets/table-details-arrow.svg";
import ModalCustom from "../../../../../../components/modal/modal";
import SecurityDetailsModalContent from "../security-details-modal-content/security-details-modal-content";
import {formatDate, toCurrency} from "../../../../../../helpr/helper";
import {
  COUPON_FREQUENCY_OTHERS,
  COUPON_FREQUENCY_ZERO,
  COUPON_TYPE_DISCOUNT,
  COUPON_TYPE_FIXED,
  COUPON_TYPE_FLOATING,
  COUPON_TYPE_STEPPED, TERM_SHEET_CONFIRMED, TERM_SHEET_DRAFT, TERM_SHEET_REJECTED, TERM_SHEET_SUBMITTED
} from "../../../../../../helpr/constants";
import {
  getPrincipalRepaymentSched, getTransferOfSecurityRestrictions, getWTPEIRemittanceConvention
} from "../../../../../../helpr/listingFormData";

const TermSheetSecurities = ({context, admin}) => {
  //Modal State
  const [showModal, setShowModal] = useState(false);
  const selectedSecurity = useRef({});
  const { termSheet, editAllowed, institutionCode } = context;
  const [securityList, setSecurityList] = useState(termSheet.securityList)
  const tableHeaders = [
    {value: 'Name of Security', class: ''},
    {value: 'Issue / Reopening Amount', class: 'align-right'},
    {value: 'Maturity Date', class: ''},
    {value: 'Issue/Listing Date', class: ''}
  ]

  const showSecurityDetails = (security) => {
    const s = termSheet.securityList.find(state => state.id === security.id)
    selectedSecurity.current = s
    setShowModal(true)
  }

  const renderWPTEIValue = key => getWTPEIRemittanceConvention().filter(t => t.value === key)[0].name;
  const renderPrincipalRepaymentSchedValue = key => getPrincipalRepaymentSched().filter(t => t.value === key)[0].name;
  const renderRestrictionValue = key => {
    const result = getTransferOfSecurityRestrictions().filter(t => t.value === key);
    if(result.length > 0){
      return result[0].name;
    }
    return key;
  }

  return (
    <div className={`${styles['term-sheet-securities']} ${styles['panel']}`} >
      <Row>
        <Col>
          <div className={styles['table-heading']}>
            Securities
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['label']}>
            Offer Period: <span className={styles['value']}>{termSheet.offerPeriodFrom ? `${formatDate(termSheet.offerPeriodFrom)} - ${formatDate(termSheet.offerPeriodTo)}` : ''}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      <Row>
        <Col lg={6}>
          <div className={styles['label']}>
            Year Basis: <span className={styles['value']}>{termSheet.yearBasis}</span>
          </div>
        </Col>
        <Col lg={6}>
          <div className={styles['label']}>
            WTPEI Remittance Convention: <span className={styles['value']}>{
            termSheet.wtpeiRemittanceConvention ? renderWPTEIValue(termSheet.wtpeiRemittanceConvention) : ''}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      <Row>
        <Col lg={6}>
          <div className={styles['label']}>
            Day Count Convention: <span className={styles['value']}>{termSheet.dayCountConvention}</span>
          </div>
        </Col>
        <Col lg={6}>
          <div className={styles['label']}>
            Principal Repayment Schedule: <span className={`${styles['value']} ${styles['wrap']}`}>{
            termSheet.principalRepaymentSched ? renderPrincipalRepaymentSchedValue(termSheet.principalRepaymentSched) : ''}
            {termSheet.principalRepaymentSched === 'AMORTIZED' ? ` (${termSheet.amortizationSched})` : ''}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['label']}>
            Description of Pre-termination Provisions: <span className={`${styles['value']} ${styles['wrap']}`}>
            {termSheet.preterminationProvisionDescription ? termSheet.preterminationProvisionDescription : '-'}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['label']}>
            Restriction on Transfer of Security: <span className={`${styles['value']} ${styles['wrap']}`}>{
            termSheet.transferOfSecurityRestrictions? renderRestrictionValue(termSheet.transferOfSecurityRestrictions) : ''}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      <Row>
        <Col lg={6}>
          <div className={styles['label']}>
            Ownership Limit: <span className={styles['value']}>
            {termSheet.ownershipLimit.type === 'N/A' || termSheet.ownershipLimit.type === ""  ? termSheet.ownershipLimit.type
            : `${termSheet.ownershipLimit.type} (${termSheet.ownershipLimit.percentage}%)`}
          </span>
          </div>
        </Col>
        <Col lg={6}>
          <div className={styles['label']}>
            Tax Applicable: <span className={styles['value']}>{termSheet.tax.applicable ? `Yes (${termSheet.tax.percentage}%)` : 'No'}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      <Row>
        <Col><div className={styles['spacing']}></div></Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Table responsive>
            <thead>
            <tr>
              {tableHeaders.map(
                (header, index) => {
                  return <th className={styles[header['class']]} key={index}>{header.value}</th>
                }
              )}
            </tr>
            </thead>
            <tbody>
            {
              securityList.map((s, index) => {
                return (
                  <tr key={index}>
                    <td>{s.prefShortName}</td>
                    <td><div className={styles['align-right']}>{`${s.currency} ${toCurrency(s.amount)}`}</div></td>
                    <td>{formatDate(s.maturityDate)}</td>
                    <td>{formatDate(s.listingDate)}</td>
                    <td className={styles['detail-arrow']} >
                      <img alt="See Details" src={detailsArrowIcon} onClick={() => showSecurityDetails(s)} />
                    </td>
                  </tr>
                )
              })
            }
            </tbody>
          </Table>
          {
            securityList.length > 0 ? ''
              : <div className={styles['no-data']}>No securities to display.</div>
          }
        </Col>
      </Row>
      <ModalCustom
        show={showModal}
        title="Security Details"
        onClose={() => setShowModal(false)}
        component={<SecurityDetailsModalContent termSheet={termSheet} security={selectedSecurity} setSecurityList={setSecurityList} onClose={() => setShowModal(false)} admin={admin} editAllowed={editAllowed} institutionCode={institutionCode}/>}
        style={styles['security-details-modal']} />
    </div>
  )
}

export default TermSheetSecurities;

